<template>
    <div>
        <label> <slot> Users: </slot></label>
        <Button class="mt-2" :label="buttonLabel" @click="toggleDialog(true)" />
        <UsersSelectionDialog v-if="dialogForm" @users-selected="usersSelected" @hide-dialog="toggleDialog(false)" />
    </div>
</template>

<script setup>
import UsersSelectionDialog from './UsersSelectionDialog.vue';

import { ref, computed, watch, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';

import { userStore } from '../../../store/global-stores.js';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    modelValue: Array,
});

// Store states
const { activePanelUsers } = storeToRefs(userStore);

// Component states
const dialogForm = ref(false);

// Computed properties
const buttonLabel = computed(() => {
    return activePanelUsers.value?.length > 0 ? `${activePanelUsers.value?.length} users selected` : 'Select Users Assigned';
});

watch(
    () => props.modelValue,
    () => {
        // If it means that the modelValue have been cleared so this needs reflection on overall components states as well
        if (props.modelValue?.length <= 0) {
            // We will just clear off the activePanelUsers information here directly
            cleanPanelUsers();
        }
    }
);

// When the panel unmounts, make sure to clean the cache information regarding activePanelUsers
onUnmounted(() => {
    cleanPanelUsers();
});

// Toggles dialog form
const toggleDialog = (flag) => {
    dialogForm.value = flag;
};

const usersSelected = (userIds) => {
    emit('update:modelValue', userIds);
};

const cleanPanelUsers = () => {
    activePanelUsers.value = [];
};
</script>
